import { faPaperclip } from '@fortawesome/pro-light-svg-icons/faPaperclip'

import { getSvgFromIcon } from 'components/TinyMceEditor/utils'
import { maxFileSizeInMb } from 'utils/file'
import { colors } from 'utils/colors'

import { MAX_FILE_SIZE } from 'modules/Settings/EmailSignature/constants'

export const useDefaultEmailFormToolbar = ({
  isUploadLoading,
  filePicker,
  maxFileSizeInbytes = MAX_FILE_SIZE,
}: {
  isUploadLoading?: boolean
  filePicker: VoidFunction
  maxFileSizeInbytes?: number
}) => ({
  toolbar:
    'bold italic underline bullist numlist indent outdent link unlink removeformat fontsize emailAttachmentButton',
  emailCustomButton: (editor: any) => {
    // add custom toolbar buttons
    editor.ui.registry.addToggleButton('emailAttachmentButton', {
      icon: 'paper-clip',
      onAction: (_: any) => {
        if (!isUploadLoading) filePicker()
      },
    })

    // add custom icons
    editor.ui.registry.addIcon(
      'paper-clip',
      `<div style="margin: 0px 4px; display: flex;">
          ${getSvgFromIcon(faPaperclip, 17, 17)} 
          <p 
            style="
              color: ${colors.gray5}; 
              margin-left: 8px; 
              font-size: 13px;"
          >
            (Max ${maxFileSizeInMb(maxFileSizeInbytes)}MB)
          </p>
        </div>`,
    )
  },
})
